import { Navigate, useLocation } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { useAuth } from "@/lib/authContext";

export default function RequireAuth({ children }) {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div
        data-testid="auth-splash"
        className="flex h-screen w-full items-center justify-center bg-[#F7F7F5]"
      >
        <div className="flex flex-col items-center gap-3">
          <div className="flex h-10 w-10 animate-pulse items-center justify-center rounded-xl bg-gradient-to-br from-zinc-900 to-black">
            <Sparkles className="h-4 w-4 text-white" strokeWidth={2.4} />
          </div>
          <div className="text-[11px] font-semibold uppercase tracking-[0.2em] text-zinc-500">
            Boardroom warming up…
          </div>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    const from = location.pathname + location.search + location.hash;
    return <Navigate to={`/login?from=${encodeURIComponent(from)}`} replace />;
  }

  return children;
}
